import { render, staticRenderFns } from "./index.vue?vue&type=template&id=72233bcd&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=72233bcd&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.33_babel-core@7.0.0-bridge.0_@babel+core@7.11._0e2b5307a736bd769cf7ae38e75c9f74/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72233bcd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dave/tg_usdt_monitor/telegram_admin_template/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72233bcd')) {
      api.createRecord('72233bcd', component.options)
    } else {
      api.reload('72233bcd', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=72233bcd&scoped=true", function () {
      api.rerender('72233bcd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Pagination/index.vue"
export default component.exports